import CREATIVE_ACTION_CREATORS from '../features/creative/state-management/actionCreators';

export const CREATE_MEDIA = 'CREATE_MEDIA';
export const MEDIA_UPLOADED = 'MEDIA_UPLOADED';
export const MEDIA_UPLOAD_FAILED = 'MEDIA_UPLOAD_FAILED';
export const MEDIA_UPLOAD_COMPLETED = 'MEDIA_UPLOAD_COMPLETED';
export const UPDATE_MEDIA_DIMENSIONS = 'UPDATE_MEDIA_DIMENSIONS';
export const UPDATE_MEDIA_PROPERTIES = 'UPDATE_MEDIA_PROPERTIES';
export const ADD_SHAPE = 'ADD_SHAPE';
export const ADD_FILES = 'ADD_FILES';
export const ADD_LOCAL_MEDIA = 'ADD_LOCAL_MEDIA';
export const SET_MEDIA_COLORS = 'SET_MEDIA_COLORS';

export const SHOW_BUILD_PROGRESS_MODAL = 'SHOW_BUILD_PROGRESS_MODAL';
export const HIDE_BUILD_PROGRESS_MODAL = 'HIDE_BUILD_PROGRESS_MODAL';

export const SHOW_MEDIA_UPLOAD_PROGRESS_MODAL =
  'SHOW_MEDIA_UPLOAD_PROGRESS_MODAL';
export const HIDE_MEDIA_UPLOAD_PROGRESS_MODAL =
  'HIDE_MEDIA_UPLOAD_PROGRESS_MODAL';

export const MEDIA_UPLOAD_PROGRESS = 'MEDIA_UPLOAD_PROGRESS';

export const ADD_CONTENT = 'ADD_CONTENT';

export const SET_MEDIA_SVG = 'SET_MEDIA_SVG';

export const SET_FONT = 'SET_FONT';
export const SET_FONT_SAGA = 'SET_FONT_SAGA';
export const SET_DEFAULT_FONT = 'SET_DEFAULT_FONT';

export const ADD_ELEMENT = 'ADD_ELEMENT';
export const ADD_ELEMENT_GROUP_SAGA = 'ADD_ELEMENT_GROUP_SAGA';
export const DELETE_ELEMENT_SAGA = 'DELETE_ELEMENT_SAGA';
export const DELETE_ELEMENT = 'DELETE_ELEMENT';
export const DELETE_CONTENT = 'DELETE_CONTENT';
export const DELETE_MEDIA = 'DELETE_MEDIA';

export const DELETE_GROUP_SAGA = 'DELETE_GROUP_SAGA';
export const DELETE_GROUP_KEEP_CONTENTS = 'DELETE_GROUP_KEEP_CONTENTS';
export const DELETE_GROUP_AND_CONTENTS = 'DELETE_GROUP_AND_CONTENTS';

export const UPDATE_ELEMENT_TIME_RANGE = 'UPDATE_ELEMENT_TIME_RANGE';
export const REQUEST_EDIT_ELEMENT = 'REQUEST_EDIT_ELEMENT';
export const EDIT_ELEMENT = 'EDIT_ELEMENT';
export const REORDER_ELEMENT_SHORTCUT_SAGA = 'REORDER_ELEMENT_SHORTCUT_SAGA';
export const REORDER_ELEMENT_SAGA = 'REORDER_ELEMENT_SAGA';
export const REORDER_ELEMENT = 'REORDER_ELEMENT';
export const REORDER_ELEMENT_ONE_PLACE = 'REORDER_ELEMENT_ONE_PLACE';
export const REORDER_ELEMENT_ONE_PLACE_WITHIN_GROUP =
  'REORDER_ELEMENT_ONE_PLACE_WITHIN_GROUP';
export const REPLACE_ELEMENT_CONTENT = 'REPLACE_ELEMENT_CONTENT';
export const UPDATE_ELEMENT_GROUP_ROLE = 'UPDATE_ELEMENT_GROUP_ROLE';
export const UPDATE_ELEMENT_NAME = 'UPDATE_ELEMENT_NAME';
export const UPDATE_ELEMENT_META_SIZE = 'UPDATE_ELEMENT_META_SIZE';
export const UPDATE_ELEMENT_META_TEMPLATE_EXCLUSION =
  'UPDATE_ELEMENT_META_TEMPLATE_EXCLUSION';
export const UPDATE_ELEMENT_META_TEMPLATE_FIT_MODE =
  'UPDATE_ELEMENT_META_TEMPLATE_FIT_MODE';

export const WINDOW_RESIZE = 'WINDOW_RESIZE';

export const SCRUB_TO_ELEMENT = 'SCRUB_TO_ELEMENT';

export const ZOOM = 'ZOOM';
export const TOGGLE_PREVIEW = 'TOGGLE_PREVIEW';

export const EDIT_CREATIVE = 'EDIT_CREATIVE';
export const LOAD_CREATIVE = 'LOAD_CREATIVE';
export const LOAD_CREATIVE_START = 'LOAD_CREATIVE_START';
export const LOAD_CREATIVE_END = 'LOAD_CREATIVE_END';
export const LOAD_CREATIVE_ERROR = 'LOAD_CREATIVE_ERROR';
export const SET_CREATIVE_ID = 'SET_CREATIVE_ID';
export const DELETE_CREATIVE = 'DELETE_CREATIVE';
export const DELETE_CREATIVE_START = 'DELETE_CREATIVE_START';
export const DELETE_CREATIVE_END = 'DELETE_CREATIVE_END';
export const DELETE_CREATIVE_ERROR = 'DELETE_CREATIVE_ERROR';
export const SET_DELETE_MODAL_VISIBLE = 'SET_DELETE_MODAL_VISIBLE';
export const UPDATE_CREATIVE = 'UPDATE_CREATIVE';
export const UPDATE_TEMPLATE_CREATIVE = 'UPDATE_TEMPLATE_CREATIVE';

export const LOAD_CREATIVE_LIST = 'LOAD_CREATIVE_LIST';
export const LOAD_CREATIVE_LIST_START = 'LOAD_CREATIVE_LIST_START';
export const LOAD_CREATIVE_LIST_END = 'LOAD_CREATIVE_LIST_END';
export const LOAD_CREATIVE_LIST_ERROR = 'LOAD_CREATIVE_LIST_ERROR';
export const SET_CREATIVE_LIST = 'SET_CREATIVE_LIST';
export const ADD_CREATIVE_TO_LIST = 'ADD_CREATIVE_TO_LIST';

export const LOAD_MEDIA_LIST = 'LOAD_MEDIA_LIST';
export const LOAD_MEDIA_LIST_START = 'LOAD_MEDIA_LIST_START';
export const LOAD_MEDIA_LIST_END = 'LOAD_MEDIA_LIST_END';
export const LOAD_MEDIA_LIST_ERROR = 'LOAD_MEDIA_LIST_ERROR';
export const SET_MEDIA_LIST = 'SET_MEDIA_LIST';

export const LOAD_UI_FONTS = 'LOAD_UI_FONTS';
export const LOAD_FONT_LIST = 'LOAD_FONT_LIST';
export const SET_FONTS = 'SET_FONTS';
export const SET_FONT_DATA = 'SET_FONT_DATA';
export const LOAD_FONT_PREVIEWS = 'LOAD_FONT_PREVIEWS';
export const DOWNLOAD = 'DOWNLOAD';
export const DOWNLOAD_READY = 'DOWNLOAD_READY';

export const CREATIVE_BUILD_PROGRESS = 'CREATIVE_BUILD_PROGRESS';
export const CREATIVE_PUBLISH_PROGRESS = 'CREATIVE_PUBLISH_PROGRESS';

export const PUBLISH_SAGA = 'PUBLISH_SAGA';
export const PUBLISH_CALL_COMPLETE = 'PUBLISH_CALL_COMPLETE';
export const BUILD_CALL_COMPLETE = 'BUILD_CALL_COMPLETE';
export const OPEN_LAST_PUBLISHED_ASSET = 'OPEN_LAST_PUBLISHED_ASSET';
export const BUILD_CREATIVE_START = 'BUILD_CREATIVE_START';
export const BUILD_CREATIVE_END = 'BUILD_CREATIVE_END';
export const BUILD_CREATIVE_ERROR = 'BUILD_CREATIVE_ERROR';

export const SAVE_AND_BUILD_SAGA = 'SAVE_AND_BUILD_SAGA';
export const SAVE_AND_HANDOFF_SAGA = 'SAVE_AND_HANDOFF_SAGA';

export const SAVE_BUILD_AND_DOWNLOAD_SAGA = 'SAVE_BUILD_AND_DOWNLOAD_SAGA';
export const SAVE_BUILD_AND_PUBLISH_SAGA = 'SAVE_BUILD_AND_PUBLISH_SAGA';

export const SET_TEMPLATE_CREATIVE_ID = 'SET_TEMPLATE_CREATIVE_ID';
// TODO(caskew): Refactor clients to directly use action creator.
export const SET_CREATIVE_TEMPLATE =
  CREATIVE_ACTION_CREATORS.setCreativeTemplate.TYPE;
export const TOGGLE_TEMPLATE_MODE = 'TOGGLE_TEMPLATE_MODE';
export const DELETE_TEMPLATE = 'DELETE_TEMPLATE';
export const DELETE_TEMPLATE_START = 'DELETE_TEMPLATE_START';
export const DELETE_TEMPLATE_END = 'DELETE_TEMPLATE_END';
export const DELETE_TEMPLATE_ERROR = 'DELETE_TEMPLATE_ERROR';

export const SET_EDIT_TEMPLATE = 'SET_EDIT_TEMPLATE';
export const SET_EDIT_TEMPLATE_ID = 'SET_EDIT_TEMPLATE_ID';
export const SET_EDIT_TEMPLATE_ORIGINAL_TAGS =
  'SET_EDIT_TEMPLATE_ORIGINAL_TAGS';
export const SET_TEMPLATE_TAGS = 'SET_TEMPLATE_TAGS';

export const DRAG_START = 'DRAG_START';
export const DRAG_END = 'DRAG_END';
export const DRAG = 'DRAG';
export const DRAGGER_MOUSE_DOWN = 'DRAGGER_MOUSE_DOWN';
export const DRAGGER_MOUSE_UP = 'DRAGGER_MOUSE_UP';
export const MOUSE_DOWN = 'MOUSE_DOWN';
export const MOUSE_UP = 'MOUSE_UP';

export const SCALE_START = 'SCALE_START';
export const SCALE_END = 'SCALE_END';
export const SCALE = 'SCALE';

export const SIDE_SCALE_START = 'SIDE_SCALE_START';
export const SIDE_SCALE_END = 'SIDE_SCALE_END';
export const SIDE_SCALE = 'SIDE_SCALE';

export const EXPAND_START = 'EXPAND_START';
export const EXPAND_END = 'EXPAND_END';

export const ROTATE_START = 'ROTATE_START';
export const ROTATE_END = 'ROTATE_END';
export const ROTATE = 'ROTATE';

export const SET_TRANSFORMED_BY_USER = 'SET_TRANSFORMED_BY_USER';
export const SET_ALPHA = 'SET_ALPHA';
export const SET_EASING = 'SET_EASING';
export const SET_POSITION = 'SET_POSITION';
export const SET_SCALE = 'SET_SCALE';
export const SET_ROTATION = 'SET_ROTATION';

export const DELETE_KEY_UP = 'DELETE_KEY_UP';
export const KEY_UP = 'KEY_UP';

export const SET_CLIP_MAX_DURATION = 'SET_CLIP_MAX_DURATION';
export const SET_CONTENT_START_END = 'SET_CONTENT_START_END';

export const HORIZONTALLY_CENTER_IMAGE_ON_SALIENT_REGION =
  'HORIZONTALLY_CENTER_IMAGE_ON_SALIENT_REGION';

export const UPDATE_TOTAL_FRAMES = 'UPDATE_TOTAL_FRAMES';

export const PROMPT_FOR_TRANSITION = 'PROMPT_FOR_TRANSITION';

export const VIDEO_PANEL_CLICK = 'VIDEO_PANEL_CLICK';
export const CANVAS_PANEL_CLICK = 'CANVAS_PANEL_CLICK';
export const CANVAS_PANEL_MOUSE_DOWN = 'CANVAS_PANEL_MOUSE_DOWN';
export const CANVAS_PANEL_MOUSE_UP = 'CANVAS_PANEL_MOUSE_UP';

export const HIDE_UI = 'HIDE_UI';
export const SHOW_UI = 'SHOW_UI';

export const FILE_DRAG_ENTER = 'FILE_DRAG_ENTER';
export const FILE_DRAG_END = 'FILE_DRAG_END';

export const SET_NO_STOCK_MEDIA_RESULTS_AVAILABLE =
  'SET_NO_STOCK_MEDIA_RESULTS_AVAILABLE';
export const STOCK_ASSET_SEARCH_QUERY_SUBMITTED =
  'STOCK_ASSET_SEARCH_QUERY_SUBMITTED';
export const STOCK_ASSET_FETCH_NEXT_PAGE = 'STOCK_ASSET_FETCH_NEXT_PAGE';
export const ERROR_FETCHING_STOCK_MEDIA = 'ERROR_FETCHING_STOCK_MEDIA';
export const GOT_STOCK_ASSET_SEARCH_RESULTS = 'GOT_STOCK_ASSET_SEARCH_RESULTS';
export const STOCK_ASSET_SEARCH_RESULTS_LOADING =
  'STOCK_ASSET_SEARCH_RESULTS_LOADING';
export const DRAG_STOCK_MEDIA_IN_SEARCH_RESULTS =
  'DRAG_STOCK_MEDIA_IN_SEARCH_RESULTS';
export const SET_MEDIA_DRAWER_URL = 'SET_MEDIA_DRAWER_URL';
export const SELECT_SERVER_MEDIA_IN_GALLERY = 'SELECT_SERVER_MEDIA_IN_GALLERY';
export const SELECT_SCRAPED_MEDIA_IN_GALLERY =
  'SELECT_SCRAPED_MEDIA_IN_GALLERY';
export const SELECT_STOCK_MEDIA_IN_GALLERY = 'SELECT_STOCK_MEDIA_IN_GALLERY';
export const DRAG_SERVER_MEDIA_IN_GALLERY = 'DRAG_SERVER_MEDIA_IN_GALLERY';
export const DRAG_SCRAPED_MEDIA_IN_GALLERY = 'DRAG_SCRAPED_MEDIA_IN_GALLERY';

export const TOGGLE_MEDIA_GALLERY = 'TOGGLE_MEDIA_GALLERY';

// UI stuff
export const SET_USER = 'SET_USER';
export const SET_USER_PERMISSIONS = 'SET_USER_PERMISSIONS';
export const SET_WILDCARD_ORG_PERMISSIONS = 'SET_WILDCARD_ORG_PERMISSIONS';
export const SET_WILDCARD_PUB_PERMISSIONS = 'SET_WILDCARD_PUB_PERMISSIONS';
export const SET_WILDCARD_SNAP_PRO_PERMISSIONS = 'SET_WILDCARD_SNAP_PRO_PERMISSIONS';
export const SET_GLOBAL_ORG_PERMISSIONS = 'SET_GLOBAL_ORG_PERMISSIONS';
export const SET_USER_ORGANIZATIONS = 'SET_USER_ORGANIZATIONS';
export const SET_USER_ACCOUNTS = 'SET_USER_ACCOUNTS';
export const SET_USER_PUBLISHERS = 'SET_USER_PUBLISHERS';
export const SET_USER_SNAP_PRO_PROFILES = 'SET_USER_SNAP_PRO_PROFILES';
export const SET_USER_CURRENT_EDITION = 'SET_USER_CURRENT_EDITION';
export const SET_USER_CURRENT_SNAP_ID = 'SET_USER_CURRENT_SNAP_ID';
export const SET_USER_CURRENT_ACCOUNT = 'SET_USER_CURRENT_ACCOUNT';
export const SET_USER_CURRENT_ACCOUNT_PERMISSIONS =
  'SET_USER_CURRENT_ACCOUNT_PERMISSIONS';
export const SET_USER_CURRENT_ORGANIZATION = 'SET_USER_CURRENT_ORGANIZATION';
export const SET_USER_CURRENT_ORGANIZATION_PERMISSIONS =
  'SET_USER_CURRENT_ORGANIZATION_PERMISSIONS';
export const SET_USER_CURRENT_PUBLISHER = 'SET_USER_CURRENT_PUBLISHER';
export const SET_USER_CURRENT_PUBLISHER_PERMISSIONS =
  'SET_USER_CURRENT_PUBLISHER_PERMISSIONS';
export const SET_USER_CURRENT_SNAP_PRO_PROFILE = 'SET_USER_CURRENT_SNAP_PRO_PROFILE';
export const SET_USER_CURRENT_SNAP_PRO_PERMISSIONS =
  'SET_USER_CURRENT_SNAP_PRO_PERMISSIONS';
export const SET_ACCOUNT_ID_SAGA = 'SET_ACCOUNT_ID_SAGA';
export const SET_PUBLISHER_ID_SAGA = 'SET_PUBLISHER_ID_SAGA';
export const SET_SNAP_PRO_ID_SAGA = 'SET_SNAP_PRO_ID_SAGA';
export const SHOW_MEMBERSHIP_SWITCH_MODAL = 'SHOW_MEMBERSHIP_SWITCH_MODAL';

export const LOAD_PAGE_SAGA = 'LOAD_PAGE_SAGA';
export const PAGE_LOAD_START = 'PAGE_LOAD_START';
export const PAGE_LOAD_END = 'PAGE_LOAD_END';
export const SET_ACCOUNT_START = 'SET_ACCOUNT_START';
export const SET_ACCOUNT_END = 'SET_ACCOUNT_END';
export const SET_UNAUTHORIZED = 'SET_UNAUTHORIZED';
export const SET_ACCESS_FORBIDDEN = 'SET_ACCESS_FORBIDDEN';
export const LOG_OUT = 'LOG_OUT';
export const POPUP_LOGIN = 'POPUP_LOGIN';

export const OFFSET_CANVAS = 'OFFSET_CANVAS';
export const TOGGLE_BASIC_MODE = 'TOGGLE_BASIC_MODE';

export const SET_TEMPLATE_DATA_MODAL_VISIBLE =
  'SET_TEMPLATE_DATA_MODAL_VISIBLE';
export const TOGGLE_SHOW_ELEMENT_CONTEXT_OPTIONS =
  'TOGGLE_SHOW_ELEMENT_CONTEXT_OPTIONS';

export const KEYBOARD_NUDGE = 'KEYBOARD_NUDGE';
export const KEYBOARD_NUDGE_END = 'KEYBOARD_NUDGE_END';
export const ALIGN_TO_CANVAS = 'ALIGN_TO_CANVAS';
export const MOVE_ELEMENT = 'MOVE_ELEMENT';

export const UNDO = 'UNDO'; // Use to trigger _HISTORY_UNDO & AFTER_UNDO_OR_REDO
export const REDO = 'REDO'; // Use to trigger _HISTORY_REDO & AFTER_UNDO_OR_REDO
export const UNDO_REDO_HOOK = 'UNDO_REDO_HOOK'; // Use to perform actions after undo/redo in sagas.
export const RECORD_FOR_UNDO = 'RECORD_FOR_UNDO'; // Save to past
export const SPLIT_RECORDING_GROUP = 'SPLIT_RECORDING_GROUP'; // Start a separate recording.
export const WIPE_HISTORY_CLEAN = 'WIPE_HISTORY_CLEAN';

export const HISTORY_UNDO = 'HISTORY_UNDO'; // Low level undo
export const HISTORY_REDO = 'HISTORY_REDO'; // Low level redo
export const AFTER_UNDO_OR_REDO = 'AFTER_UNDO_OR_REDO'; // Use to clean up state issues caused by undo / redo

export const UI_ERROR_MODAL = 'UI_ERROR_MODAL';
export const SHOW_ERROR_MODAL = 'SHOW_ERROR_MODAL';
export const SHOW_FILE_ERROR = 'SHOW_FILE_ERROR';
export const DISMISS_ERROR_MODAL = 'DISMISS_ERROR_MODAL';
export const SET_TOOL_VISIBILITY = 'SET_TOOL_VISIBILITY';

export const SET_NEW_ELEMENT_REQUESTED = 'SET_NEW_ELEMENT_REQUESTED';
export const SET_SELECTED_MEDIA_TAB = 'SET_SELECTED_MEDIA_TAB';

export const FINISH_AUTO_SAVING = 'FINISH_AUTO_SAVING';
export const START_SAVING_AND_BUILDING = 'START_SAVING_AND_BUILDING';
export const START_PUBLISHING = 'START_PUBLISHING';
export const FINISH_SAVING_AND_BUILDING = 'FINISH_SAVING_AND_BUILDING';
export const FINISH_PUBLISHING = 'FINISH_PUBLISHING';

export const UNSUPPORTED_VERSION_ERROR = 'UNSUPPORTED_VERSION_ERROR';

export const SET_SHOULD_WARN_ABOUT_TEMPLATE_MEDIA =
  'SET_SHOULD_WARN_ABOUT_TEMPLATE_MEDIA';

export const SET_MOST_RECENT_COLORS = 'SET_MOST_RECENT_COLORS';

export const SET_ALPHA_COMPOSITE_MODE = 'SET_ALPHA_COMPOSITE_MODE';
export const SET_PREVIEW_ALPHA_COMPOSITE_MODE =
  'SET_PREVIEW_ALPHA_COMPOSITE_MODE';

export const MOVE_ELEMENT_TO_GROUP = 'MOVE_ELEMENT_TO_GROUP';
export const GROUP_ELEMENTS_SAGA = 'GROUP_ELEMENTS_SAGA';
export const REQUEST_REORDER_ELEMENT = 'REQUEST_REORDER_ELEMENT';
export const REORDER_ELEMENT_V2 = 'REORDER_ELEMENT_V2';
export const REORDER_ELEMENT_SAGA_V2 = 'REORDER_ELEMENT_SAGA_V2';

export const SET_HOVERED_GROUP = 'SET_HOVERED_GROUP';
export const SET_TIMELINE_DRAGGING = 'SET_TIMELINE_DRAGGING';
export const SET_GROUP_OPEN = 'SET_GROUP_OPEN';
